// extracted by mini-css-extract-plugin
module.exports = {"noteContainer":"RemoveFiltersNote-module__noteContainer"};